/*
 * Created on Sat Jun 19 2021
 *
 * Copyright (c) 2021 Khor Chai Hong
 */

import React, { useState, useEffect, useRef } from 'react';
import { useForm, FormProvider } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import parse from 'html-react-parser';
import preloader from "../assets/images/preloaders/03-preloader-6px-7D0D39.gif";
import { Menu, MenuItem } from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import { SuccessModal } from './find';
import TopNav from 'components/shared/top-nav';
import { Textarea, addEmptyFields, clearEmptyFields } from '../components';
import { useWindowDimensions } from "../utils/helpers";
import { AccountTypes, images, mobileImages } from '../constants';
import { postEnquiry } from 'apis/enquiry.api'
import useGetProfile from 'hooks/get-profile.hook';
import useGetMyAccount from 'hooks/get-user-account.hook';

const schema = yup.object().shape({
    name: yup
        .string()
        .required(),
    email: yup
        .string()
        .required()
        .email('Oops! Invalid email address'),
    type: yup
        .string()
        /* .required() */,
    subject: yup
        .string()
        .required(),
    message: yup
        .string()
        .required(),
});

let texts = [
    {
        label: 'Type',
        title: '',
        subtitle: `Hey, if you didn't know, the <span class="pn-bold">itch</span> crew is<br />
        currently a small workforce, embodying a<br />
        big belief than most would give us credit<br />
        for. So do pardon us if our replies are a<br />
        tad slow. Be it minutes or days, we'd still<br />
        very much love to hear from you`,
        subtitle2: `Hey, if you didn't know, the<br />
        <span class="pn-bold">itch</span> crew is currently a small<br />
        workforce, embodying a big<br />
        belief than most would give us<br />
        credit for. So do pardon us if<br />
        our replies are a tad slow. Be it<br />
        minutes or days, we'd still very<br />
        much love to hear from you.`
    },
    {
        label: 'General',
        title: 'About General Enquiries',
        subtitle: `<b>General</b> emails can be motley general.<br />
        So don't forget to address your<br />
        concerns within your subject head<br />
        for us to better understand your enquiry.<br />
        Don't worry. We're already looking into<br />
        having more specific email types for<br />
        faster turnaround replies.`,
        subtitle2: `<b>General</b> emails can be motley<br />
        general. So don't forget to<br />
        address your concerns within<br />
        your subject head for us to<br />
        better understand your<br />
        enquiry. Don't worry. We're<br />
        already looking into having<br />
        more specific email types for<br />
        faster turnaround replies.`
    },
    {
        label: 'Press',
        title: 'Press',
        subtitle: `For all <b>press</b> related enquiries, such as<br />
        mainstream or alternative media<br />
        interviews and publications, kindly<br />
        address it in your subject head for us<br />
        to expedite a reply.`,
        subtitle2: `For all <b>press</b> related enquiries,<br />
        such as mainstream or<br />
        alternative media interviews<br />
        and publications, kindly<br />
        address it in your subject head<br />
        for us to expedite a reply.`
    },
    {
        label: 'Partnerships',
        title: 'Partnerships',
        subtitle: `At <span class="pn-bold">itch</span>, we're always interested in collaborating with those who support<br />
        the humankind evolution. If you've an<br />
        event, sponsorship or other ideas for<br />
        a compounding relationship to change<br />
        the world, we'll definitely want to hear<br />
        from you!`,
        subtitle2: `At <span class="pn-bold">itch</span>, we're always<br />
        interested in collaborating with<br />
        those who support the<br />
        humankind evolution. If you've<br />
        an event, sponsorship or other<br />
        ideas for a compounding<br />
        relationship to change the<br />
        world, we'll definitely want to<br />
        hear from you!`
    }
];

export default function ContactUs() {
    const { success, profile } = useGetProfile()
    const myAccount = useGetMyAccount()
    
    // prefilled name (firstName and lastName) and email when user is logged in
    const methods = useForm({
        shouldFocusError: false,
        resolver: yupResolver(schema)
    });

    const { register, handleSubmit, setValue, reset, watch, formState: { errors, isSubmitted, isSubmitting } } = methods

    const formRef = useRef();
    const menuRef = useRef();
    const typeRef = useRef();

    const [anchorEl, setAnchorEl] = useState(null);
    const [formHasValue, setFormHasValue] = useState(false);
    const [typeHovered, setTypeHovered] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [formData, setFormData] = useState([]);
    const [emptyFields, setEmptyFields] = useState([]);
    const [index, setIndex] = useState(0);
    const [hoveredIndex, setHoveredIndex] = useState(0);
    const [typeValue, setTypeValue] = useState('');
    const { windowWidth, windowHeight, isMobile } = useWindowDimensions();

    /*
    watch(data => {        
        if (!Object.values(data).some(val => val)) {
            setFormHasValue(false);
        }
        else setFormHasValue(true);
    })
    */

    const onReset = () => {
        reset({});
        setEmptyFields([]);
        clearEmptyFields();
        setFormHasValue(false);
        setIndex(0);
        typeRef.current.innerText = texts[0].label;
        setTypeValue('');
    };
    const onSubmit = async (data, e) => {
        // setFormData(data);
        const response = await postEnquiry(data)
        setShowModal(true)
    }
    const handleOpen = () => setAnchorEl(menuRef.current);
    const handleClose = () => setAnchorEl(null);
    const selectedItem = (i) => {
        handleClose();
        typeRef.current.innerText = texts[i].label;
        setTypeValue(texts[i].label);
        setValue('type', texts[i].label);
        onBlur('type');
        setIndex(i);
        setFormHasValue(true);
    };
    const addEmptyFieldStyle = fieldName => {
        if (fieldName === 'email') {
            return emptyFields.includes(fieldName) || errors.email ? 'empty-field' : '';
        }
        return emptyFields.includes(fieldName) ? 'empty-field' : '';
    };
    const onBlur = (fieldName) => {
        if (emptyFields.includes(fieldName)) {
            tempEmptyFields = emptyFields.filter(field => field !== fieldName);
            setEmptyFields(tempEmptyFields);
        }
    }

    let tempEmptyFields = [];
    let modalEl = {
        img: '<div class="contact-us-modal-icon sprites sprites-image-2"></div>',
        text1: "Thank you, we've got it!",
        text2: "We'll get back to you soon.",
        redirect: '/login'
    }

    useEffect(() => {
        if (isSubmitted || isSubmitting) {
            addEmptyFields(errors);
            for (let [key, value] of Object.entries(errors)) {
                if (value.type === 'required') {
                    tempEmptyFields.push(key);
                }
            }
            setEmptyFields(tempEmptyFields);
        }
        // eslint-disable-next-line
    }, [isSubmitted, isSubmitting]);

    useEffect(() => {
        if (success && profile && myAccount.success && myAccount.accountSettings) {
            const {
                accountType,
                firstName,
                lastName,
                companyName
            } = profile
            setValue('name', accountType === AccountTypes.FashionCompany ? companyName : firstName + ' ' + lastName)
            setValue('email', myAccount.accountSettings.email)
            /*
            reset({
                name: accountType === AccountTypes.FashionCompany ? companyName : firstName + ' ' + lastName,
                email: myAccount.accountSettings.email
            })
            */
        }
    }, [success, profile, myAccount.success, myAccount.accountSettings])

    return (
        <>
            <div id="contact" className="wrapper" onScroll={handleClose}>
                {showModal ? <SuccessModal contactusModal={modalEl} /> : null}
                <div className="signup-bg-container">
                    <img
                        className="signup-bg top"
                        src={`${windowWidth > 926 ? images['contactus-bg.jpg'] : mobileImages['contactus-bg.jpg']}`}
                        style={isMobile ?
                            {
                                width: windowWidth,
                                height: 'auto',
                                minHeight: windowHeight
                            }
                            : null
                        }
                        alt="background"
                    />
                    {texts.slice(1).map(({ label }, i) =>
                        <img
                            key={label}
                            className="signup-bg"
                            style={{ opacity: i + 1 === hoveredIndex || (hoveredIndex === 0 && i + 1 === index) ? 1 : null }}
                            src={`${windowWidth > 926 ? images['contactus-bg' + (i + 2) + '.jpg'] : mobileImages['contactus-bg' + (i + 2) + '.jpg']}`}
                            alt="background"
                        />
                    )}
                </div>
                <div className="scroll-container">
                    <div id="faAccount" className="contact-us">
                        <div className="left-col position-relative">
                            <p className="header pink-text">contact<br />us</p>
                            <div className="small-text top" style={{ opacity: hoveredIndex > 0 || index > 0 ? 0 : null }}>
                                <span className="subtitle">{windowWidth > 926 ? parse(texts[0].subtitle) : parse(texts[0].subtitle2)}</span>
                            </div>
                            {texts.slice(1).map(({ label, title, subtitle, subtitle2 }, i) =>
                                <div key={label} className="small-text" style={{ opacity: i + 1 === hoveredIndex || (hoveredIndex === 0 && i + 1 === index) ? 1 : null }}>
                                    <span className="pink-text title pn-bold">{title}</span>
                                    <span className="subtitle">{windowWidth > 926 ? parse(subtitle) : parse(subtitle2)}</span>
                                </div>
                            )}
                        </div>
                        <FormProvider {...methods}>
                            <form
                                ref={formRef}
                                id="faForm"
                                className="signup-form"
                                autoComplete="off"
                                noValidate="novalidate"
                            >
                                <div className={emptyFields.length > 0 || errors.email ? "form-group error-popup display" : "form-group error-popup"}>
                                    <span className="error-msg pink-text">{emptyFields.length > 0 ? 'Oops! The highlighted fields are required.' : 'Oops! Please enter a valid email address.'}</span>
                                </div>
                                {windowWidth <= 926 ?
                                    <div className={`
                                        form-group menu-group 
                                        ${errors.type ? addEmptyFieldStyle('type') : ""}
                                    `}
                                        onClick={Boolean(anchorEl) ? handleClose : handleOpen}
                                    >
                                        <div ref={menuRef} className="form-control menu-label">
                                            <span ref={typeRef} style={{ color: index === 0 ? '#EC0f69' : null }}>Type</span>
                                            <input value={typeValue} {...register("type")} hidden />
                                        </div>
                                        <Menu
                                            className="menu"
                                            anchorEl={anchorEl}
                                            keepMounted
                                            open={Boolean(anchorEl)}
                                            transitionDuration={0}
                                            getContentAnchorEl={null}
                                            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                                            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                                            onClose={handleClose}
                                        >
                                            {texts.slice(1).map(({ label }, i) =>
                                                <MenuItem
                                                    key={label}
                                                    className={i + 1 === index ? "menu-item selected" : "menu-item"}
                                                    onClick={() => selectedItem(i + 1)}
                                                >
                                                    {label}
                                                </MenuItem>
                                            )}
                                        </Menu>
                                        <KeyboardArrowDownIcon onClick={Boolean(anchorEl) ? handleClose : handleOpen} />
                                    </div>
                                    : null}
                                <div className="form-group">
                                    <input
                                        className={errors.name ? 'form-control ' + addEmptyFieldStyle('name') : 'form-control'}
                                        placeholder="Your name"
                                        autoComplete="off"
                                        {...register("name")}
                                    />
                                </div>
                                <div className="form-group">
                                    <input
                                        type="email"
                                        className={errors.email ? 'form-control ' + addEmptyFieldStyle('email') : 'form-control'}
                                        placeholder="Your email"
                                        autoComplete="firstName"
                                        {...register("email")}
                                    />
                                </div>
                                {windowWidth > 926 ?
                                    <div className={`
                                    form-group menu-group 
                                    ${typeHovered ? "hovered" : ""} 
                                    ${errors.type ? addEmptyFieldStyle('type') : ""}
                                `}
                                        onMouseEnter={() => { handleOpen(); setTypeHovered(true) }}
                                        onMouseLeave={() => { handleClose(); setTypeHovered(false) }}
                                    >
                                        <div ref={menuRef} className="form-control menu-label">
                                            <span ref={typeRef} style={{ color: index === 0 ? '#EC0f69' : null }}>Type</span>
                                            <input value={typeValue} {...register("type")} hidden />
                                        </div>
                                        <Menu
                                            className="menu"
                                            anchorEl={anchorEl}
                                            keepMounted
                                            open={Boolean(anchorEl)}
                                            transitionDuration={0}
                                            getContentAnchorEl={null}
                                            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                                            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                                            // onEnter={() => setTypeHovered(true)}
                                            // onExit={() => setTypeHovered(false)}
                                            onClose={handleClose}
                                        >
                                            {texts.slice(1).map(({ label }, i) =>
                                                <MenuItem
                                                    key={label}
                                                    className={i + 1 === index ? "menu-item selected" : "menu-item"}
                                                    onClick={() => selectedItem(i + 1)}
                                                    onMouseEnter={() => setHoveredIndex(i + 1)}
                                                    onMouseLeave={() => setHoveredIndex(0)}
                                                >
                                                    {label}
                                                </MenuItem>
                                            )}
                                        </Menu>
                                        <KeyboardArrowDownIcon onClick={Boolean(anchorEl) ? handleClose : handleOpen} />
                                    </div>
                                    : null}
                                <div className="form-group">
                                    <input
                                        className={errors.subject ? 'form-control pink-placeholder ' + addEmptyFieldStyle('subject') : 'form-control pink-placeholder'}
                                        placeholder="Subject"
                                        autoComplete="firstName"
                                        {...register("subject")}
                                        disabled={index === 0}
                                    />
                                </div>
                                <Textarea label="Message" name="message" formGroupClassName={"message " + (index === 0 ? "disabled" : "")} labelClassName="message-label" textareaClassName="custom-scroller" disabled={index === 0} />
                                {/* <div className="form-group">
                                <label htmlFor="message" className="pink-text message-label">Message</label>
                                <textarea
                                    rows="9"
                                    id="message"
                                    className={errors.message ? 'form-control pink-placeholder ' + addEmptyFieldStyle('message') : 'form-control pink-placeholder'}
                                    autoComplete="firstName"
                                    {...register("message")}
                                    disabled={index === 0}
                                />
                                </div> */}
                                <div className="contact-us-buttons pn-bold">
                                    <button
                                        type="button"
                                        className="footer-buttons float-left pink-text reset"
                                        disabled={!formHasValue}
                                        onClick={onReset}
                                    >Reset</button>
                                    <button
                                        className="footer-buttons float-right pink-text confirm"
                                        disabled={!formHasValue}
                                        onClick={handleSubmit(onSubmit)}
                                    >
                                        <span className={formData.length !== 0 ? 'd-none' : ''}>Send</span>
                                        <img className={formData.length !== 0 ? '' : 'd-none'} src={preloader} alt="preloader" />
                                    </button>
                                </div>
                            </form>
                        </FormProvider>
                    </div>
                </div>
            </div>
        </>
    );
}